export default __webpack_public_path__ + "static/garden_design1-2481424cbad62331a2300b48072dde49.webp";